import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import MembersApi from '../../services/portal-api/MembersApi';
import GlobalsApi from '../../services/portal-api/GlobalsApi';
import TextInput from '../../components/Form/components/TextInput';
import AuthService from '../../services/AuthService';
import RestartQueue from '../AdminTools/components/components/RestartQueue';
import Header from '../../components/Header';
import LoadingSpinner from '../../components/LoadingSpinner';
import TextAreaInput from '../../components/Form/components/TextInput/TextAreaInput';
import swal from 'sweetalert';
import Pagination from 'react-js-pagination';
import moment from "moment/moment";
import NavigationBar from '../Navigation';

class News extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {
                id: '',
                title: '',
                description: ''
            },
            isLoading: false,
            errors: {},
            isEdited: false,
            totalNews: 0,
            currentPage: 1,
            news: []
        };
        this.deleteNews = this.deleteNews.bind(this);
    }

    componentDidMount() {
        this.getNews();
    }

    getNews = () => {
        GlobalsApi.getNews((response) => {
            if (response.success) {
                console.log(response)
                this.setState({
                    news: response.json.data,
                    totalNews: response.json.total
                }, () => {
                    console.log(this.state.news);
                });
            } 
        }, true);
    }

    handlePageChange = (pageNumber) => {
        this.setState({
            currentPage: pageNumber
        }, () => {
            this.getNews();
        });
    }

    handleInput = (event) => {
        const errors = this.state.errors;
        const name = event.target.name;
        delete errors[name];
        let data = this.state.data;

        data[name] =  event.target.value;

        this.setState({
            data: data,
            errors: errors,
            isEdited: true,
        });
    }

    handleSubmit = (event) => {
        event.preventDefault();
        MembersApi.setNews(this.state.data, (response) => {
            if (response.json.success) {
                this.setState({
                    isEdited: false,
                    data: {
                        id: '',
                        title: '',
                        description: ''
                    }
                }, () => {
                    this.getNews();
                    swal("Saved Successfully", {
                        icon: "success",
                        buttons: false,
                        timer: 3000
                    });
                });
            } else {
                swal("Something went wrong", {
                    icon: "error",
                    buttons: false,
                    timer: 3000
                });
            }
        })
    } 

    editNews = (element) => {
        return () => {
            this.setState({
                data: {
                    id: element.id,
                    title: element.title,
                    description: element.description
                }
            });
        }
    }

    deleteNews(id) {
        return () => {
            swal({
                title: "Are you sure?",
                text: "you really want to delete this news?",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
            .then((willDelete) => {
                if (willDelete) {
                    MembersApi.deleteNews(id, (response) => {
                        if (response.success) {
                            swal(response.json.message, {
                                icon: "success",
                                buttons: false,
                                timer: 3000
                            });
                            this.getNews();
                        } else {
                            this.props.sessionLog(response);
                        }
                    });
                }
            });
        }
    }

    convertUTCToLocalTime = (dateString) => {
        let date = new Date(dateString);
        const milliseconds = Date.UTC(
            date.getFullYear(),
            date.getMonth(),
            date.getDate(),
            date.getHours(),
            date.getMinutes(),
            date.getSeconds(),
        );
        const localTime = new Date(milliseconds);

        let cd = localTime.getFullYear() + "-" + (localTime.getMonth() + 1) + "-" + localTime.getDate() + " " + localTime.getHours() + ":" + localTime.getMinutes() + ":" + localTime.getSeconds();
        return moment(cd).format('YYYY-MM-DD  h:mm A');
    };

    checkButton = () => {
        return (
            <svg stroke="currentColor" fill="currentColor" strokeWidth="0" version="1" viewBox="0 0 48 48" enableBackground="new 0 0 48 48" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><polygon fill="#43A047" points="40.6,12.1 17,35.7 7.4,26.1 4.6,29 17,41.3 43.4,14.9"></polygon></svg>
        )
    }

    cancelButton = () => {
        return (
            <svg stroke="currentColor" fill="currentColor" strokeWidth="0" version="1" viewBox="0 0 48 48" enableBackground="new 0 0 48 48" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="#D50000" d="M24,6C14.1,6,6,14.1,6,24s8.1,18,18,18s18-8.1,18-18S33.9,6,24,6z M24,10c3.1,0,6,1.1,8.4,2.8L12.8,32.4 C11.1,30,10,27.1,10,24C10,16.3,16.3,10,24,10z M24,38c-3.1,0-6-1.1-8.4-2.8l19.6-19.6C36.9,18,38,20.9,38,24C38,31.7,31.7,38,24,38 z"></path></svg>
        )
    }

    markAsImportant = (id) => {
        swal({
            title: "Are you sure?",
            text: "you really want to make this important?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
        .then((willDelete) => {
            if (willDelete) {
                MembersApi.markAsImportant(id, (response) => {
                    if (response.success) {
                        swal(response.json.message, {
                            icon: "success",
                            buttons: false,
                            timer: 3000
                        });
                        this.getNews();
                    } else {
                        swal(response.json.message, {
                            icon: "error",
                            buttons: false,
                            timer: 3000
                        });
                    }
                });
            }
        });
    }

    render() {
        const paginationStyles = {
            display: 'flex',
            flexWrap: 'nowrap',
            overflowX: 'auto',
            marginTop: '10px',
        }  
        let rows = [];
        this.state.news.forEach((element, index) => {
            rows.push(
                <tr key={index}>
                    <td><strong>{element.title}</strong></td>
                    <td>{element.description}</td>
                    <td>
                        <React.Fragment>
                            {element.important == 1 ?
                                <a onClick={() => this.markAsImportant(element.id)}>
                                    {this.checkButton()}
                                </a>
                                :
                                <a onClick={() => this.markAsImportant(element.id)}>
                                    {this.cancelButton()}
                                </a>
                            }
                        </React.Fragment>
                    </td>
                    <td>{this.convertUTCToLocalTime(element.created_at)}</td>
                    <td>
                        <table style={{ marginTop: 0 }}>
                            <tbody>
                                <tr>
                                    <td style={{ border: 0, background: "transparent", textAlign: "right" }}><a href="javascript:void(0)" className="btn btn--xsmall btn--blue" onClick={this.editNews(element)}>Edit</a></td>
                                    <td style={{ border: 0, background: "transparent" }}><a href="javascript:void(0)" className="btn btn--xsmall btn--red" onClick={() => this.deleteNews(element.id)()}>Remove</a></td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            );
        })

        return (
            <div>
                <Header />
                <main className="content padding--80--bot" role="main">
                    <div className="container container--wide padding--40">
                        {AuthService.getAdminType() == 1 &&
                            <div className="info-wrap col gutter--40 margin--10--bot" style={{ borderBottom: "1px solid #ccc", display: "flex", flexWrap: "wrap" }}>
                                <div className="col">
                                    <NavigationBar />
                                </div>
                            </div>
                        }
                        <h2 className="text--light text--color text--40">News</h2>
                        
                        {AuthService.can('news') &&
                            <form onSubmit={this.handleSubmit} className={AuthService.isAdmin() ? "validate loading--inline " : "margin--40--top validate loading--inline padding--90--bot"} autoComplete="off">
                                <span></span>
                                <div className="col-2 gutter--40 ">
                                    <div className="col">
                                        <TextInput
                                            name="title"
                                            label="Title"
                                            placeholder="Title"
                                            value={this.state.data.title}
                                            error={this.state.errors.title}
                                            onChange={this.handleInput}
                                            required={true}
                                        />
                                    </div>
                                    <div className="col">
                                        <div className="col">
                                            <TextAreaInput 
                                                name="description"
                                                label="Description"
                                                placeholder="Description"
                                                value={this.state.data.description}
                                                error={this.state.errors.description}
                                                onChange={this.handleInput}
                                                required={true}
                                                
                                            />
                                        </div>
                                    </div>
                                    <footer className="footer--form clearfix">
                                        <div className="footer--form__left">

                                        </div>
                                        <div className="footer--form__right">
                                            <button type="submit" className="btn btn--large btn--color">Save</button>
                                        </div>
                                    </footer>
                                </div>
                            </form>
                        }
                        <table>
                            <thead>
                                <tr>
                                    <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 999, verticalAlign: 'top' }}>Title</th>
                                    <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 999, verticalAlign: 'top' }}>Description</th>
                                    <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 999, verticalAlign: 'top' }}>Mark as Important</th>
                                    <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 999, verticalAlign: 'top' }}>Created at</th>
                                    <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 999, verticalAlign: 'middle', textAlign: 'center' }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows} 
                            </tbody>
                        </table>
                        {this.state.totalNews > 50 &&
                            <div style={paginationStyles}>
                                <nav>
                                    <Pagination
                                        activePage={this.state.currentPage}
                                        itemsCountPerPage={50}
                                        totalItemsCount={this.state.totalNews}
                                        pageRangeDisplayed={5}
                                        onChange={handlePageChange}
                                        innerClass="pagination"
                                    />
                                </nav>
                            </div>
                        }
                    </div>
                </main>
                <LoadingSpinner  />
            </div>
        )
    }
}

export default News;